<template>
	<v-item-group multiple v-model="infoToComponent.selections">
		<v-container fluid class="pt-0 overflow-y-auto">
				<!-- <v-col cols="12"> -->
			<v-text-field class="mt-3" outlined dense hide-details v-model="search" :label="$ml.get('search')" prepend-inner-icon="mdi-magnify" ></v-text-field>
				<!-- </v-col> -->
			<v-row dense class="fill-height" :justify="!renderList.length?'center':'start'" :align="!renderList.length?'center':'start'" style="max-height: 300px; height: 300px;">
				<v-col cols="auto" v-show="!renderList.length">
					<strong> {{ $ml.get('data_no_found') }} </strong>
				</v-col>
				<v-col 
					v-for  	= "(item, idxDevice) of renderList"
					:key 	= "'list_device_sidebar' + idxDevice" 
					cols 	= "auto"  
				>
					<!-- @click 	="sel(n)"  -->
					<v-item v-slot:default = "{ active, toggle }" :value="item.uuid">
						<v-card 
							dark  
							outlined
							:color 	= "isItemSelected(item) ? 'primary': '' "  
							style 	= "width:120px; height: 100%;"  
							@click	= "toggle()" 
							class 	= "pl-0 ma-0" 
						>	
						<!--  style = "font-size: 80%; line-height: 110%" -->
							<v-card-title class = "pa-0 ma-0 primary justify-center caption black--text">
								<!-- <v-spacer></v-spacer> -->
								{{ item.name }}
							</v-card-title>																		
								<v-img
					         		contain
									:src="renderUrlImg(item)"											
					         		@error = "item.imgUrl = '/img/no_img_found.png'"
					         		:width  = "120" 
					         		:height = "'120'"
					         		:lazy-src="$logos.mark || ($vuetify.theme.dark ? $logos.login_night : $logos.login)"
					         		:aspect-ratio="16/9"
								></v-img>
					            <v-card-actions style="font-size: 80%; line-height: 110%; justify-content: center;">
					            	<span> # {{item.realIndex}}</span><br>
					            </v-card-actions>										             	
							</v-card>
						</v-item>
					</v-col>
				</v-row>	
				<div class="text-center">
					<v-pagination
				      v-model="page"
				      :length="pageCount"
				      :total-visible="7"
				    ></v-pagination>
				</div>
			</v-container>
			
		</v-item-group>
</template>
<script type="text/javascript">
	export default{
		name : "ItemsGroupFaces",
		props : ["infoToComponent", "infoToFilter"],
		data : ()=>({
			selecteds : [],
			page: 1,
			itemsPerPage: 6, 
			total : 0,
			search : "",
		}),
		computed:{
			renderList(){
				if(this.infoToComponent?.data && this.infoToComponent.data.length){
					if(this.search){
						const temp = this.infoToComponent.data.filter(x=> (x?.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 || x.uuid.indexOf(this.search.toLowerCase()) > -1 ))
						this.total=temp.length;
						return this.renderPaginate(temp);
					}else{
						this.total=this.infoToComponent.data.length;
						return this.renderPaginate(this.infoToComponent.data)
					}
				}
				return [] 
			},
			pageCount(){
				return Math.ceil(this.total/this.itemsPerPage);
			},
		},
		watch:{
			search(){
				this.page = 1; // Reset page when search changes
			},
			pageCount(newVal){
				// Reset to page 1 if current page is greater than total pages
				if(this.page > newVal && newVal > 0){
					this.page = 1;
				}
			}
		},
		methods:{			
			renderUrlImg(item){				
				if(item && item?.face_cropping && item && item?.face_cropping.length){
					item.imgUrl=this.$URL+item?.face_cropping?.[0]?.url;
					return item.imgUrl
				}
				return ""
			},
			renderPaginate(items){
				const start = (this.page-1)*this.itemsPerPage
				return items.slice(start, start + this.itemsPerPage).map((item, index) => ({
					...item,
					realIndex: start + index + 1
				})); 
			},
			isItemSelected(item){
				// Verificar si el item está realmente seleccionado en la lista actual
				if(!this.infoToComponent?.selections || !Array.isArray(this.infoToComponent.selections)){
					return false;
				}
				return this.infoToComponent.selections.includes(item.uuid);
			}
		}, // methods
	}
</script>